'use client';

import { useState } from 'react';
import type { VisibilityType } from '@/components/visibility-selector';

// Simplified chat visibility hook for stateless mode
export function useChatVisibility({
  chatId,
  initialVisibilityType,
}: {
  chatId: string;
  initialVisibilityType: VisibilityType;
}) {
  const [visibilityType, setVisibilityType] = useState<VisibilityType>(initialVisibilityType);

  // In stateless mode, visibility changes are only local and not persisted
  const updateVisibilityType = (updatedVisibilityType: VisibilityType) => {
    setVisibilityType(updatedVisibilityType);
  };

  return { visibilityType, setVisibilityType: updateVisibilityType };
}
